import { h, Component } from "preact";

export default class LabelViewerSizeHandle extends Component<
  ILabelViewerSizeHandleProps,
  any
> {
  clientY: number;
  dragHandler: HTMLElement;
  private previousClientY: number = 0;
  private dragButton: HTMLElement;

  constructor(props: ILabelViewerSizeHandleProps) {
    super(props);

    this.startDrag = this.startDrag.bind(this);
    this.onDrag = this.onDrag.bind(this);
  }

  startDrag(event: DragEvent | TouchEvent): void {
    if (event.type === "touchstart") {
      event = event as TouchEvent;
      const touch: any = event.touches[0];
      this.previousClientY = touch.clientY * touch.radiusY;
    }

    if (event.type === "dragstart") {
      event = event as DragEvent;
      event.dataTransfer.setDragImage(document.createElement("span"), 0, 0);
    }

    this.props.onDragStart();
  }

  onDrag(event: any): void {
    event.preventDefault();
    let offsetY: number = event.offsetY;

    if (event.type === "touchmove" || event.type === "touchend") {
      const touch: any = event.changedTouches[0];
      const clientY: number = touch.clientY * touch.radiusY;
      offsetY = clientY - this.previousClientY;
      this.previousClientY = clientY;
    }

    if (event.clientY === 0 && event.clientX === 0) {
      return;
    }

    this.props.onDrag(offsetY);
  }

  render(): JSX.Element {
    return (
      <div className="slider__control js-slider-control ">
        <div
          className="card__handle js-preview-handle"
          ref={(e: HTMLElement) => (this.dragHandler = e)}
          draggable
          onTouchStart={this.startDrag}
          onTouchMove={this.onDrag}
          onTouchEnd={this.onDrag}
          onDrag={this.onDrag}
          onDragOver={this.onDrag}
          onDragStart={this.startDrag}
          onDragEnd={this.onDrag}
          onDragLeave={this.onDrag}
        >
          <div
            className="card__handle--drag-button"
            ref={(e: HTMLElement) => (this.dragButton = e)}
          />
        </div>
      </div>
    );
  }
}

interface ILabelViewerSizeHandleProps {
  onDrag: (offsetY: number) => void;
  onDragStart: Function;
}
